<template>
    <div class="stDialog" v-show="toggleStDialog">
        <div class="stMask"></div>
        <div class="stWinWrap">
            <div class="stWinHeader">
                <span class="stWinTitle" >{{title}}</span>
                <!-- <div class="stWinClose" @click="$emit('closeDialog')"><img src="../assets/images/close.png"></div> -->
            </div>
            <div class="stWinBody" id='stWinBody'>
               <slot></slot>
            </div>
            <div class="stWinFooter">
                <span class="stMbgc" @click="$emit('closeDialog') ">取消</span>
                <span class="stFbgc" @click="$emit('saveDialog')">{{defindBtnText?defindBtnText:"保存"}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'myDialog',
    props:[
        'title','toggleStDialog',"setScrollTop","defindBtnText"
    ],
    watch:{
        toggleStDialog(newVal,oldVal){
            const stWinBody= document.getElementById('stWinBody')
            if( newVal && this.setScrollTop){
                setTimeout(()=>{
                    stWinBody.scrollTop=0;
                })
            }
        },
        
    },
    data:function(){
        return {
            
        }
    },
}
</script>
<style scoped>
.stDialog{
	height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
}
.stMask{
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0,0,0,0.3);
}
.stWinWrap{
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
   /* min-width: 406px;
    min-height: 200px; */
    transform: translate(-50%, -50%);
    -webkit-transform:translate(-50%,-50%);
    background: #fff;
    padding-bottom: 50px;
    z-index: 15;
    border-bottom: 1px solid #e3e3e3;
    border-radius: 6px;
}
.stWinHeader{
	position: relative;
	height:40px;
	line-height:40px;
	border-bottom:1px solid #e3e3e3;
	text-align: center;
    font-size: 18px;
    font-weight: bold;
}
.winClose{
	position: absolute;
	width: .8rem;
	right: 0;
	top: 0;
	cursor: pointer;
}
.winClose img{
	width:.5rem;
}
.stWinBody{
	max-height: 300px;
	overflow-y: auto;
    border-bottom: 1px solid #e3e3e3;
}
.stWinFooter{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
	height: 30px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
}
.stWinFooter  span{
	width:80px;
	height:30px;
	line-height:30px;
	color:#fff;
	margin:0 12px;
	cursor:pointer;
    text-align: center;
    border-radius: 2px;
}

</style>



